import React from 'react';

export default function Messaging() {
  return (
    <svg className="availabilityIcon availabilityIcon-messaging" width="32" height="32">
      <g transform="translate(1 1)" stroke="#111" fill="none" fillRule="evenodd">
        <rect x=".5" y=".5" width="29" height="29" rx="14.5" />
        <path
          d="M16.082 20.5l-3.707 3.707V20.5h-.25C8.755 20.5 6 17.745 6 14.375S8.755 8.25 12.125 8.25h6c3.37 0 6.125 2.755 6.125 6.125S21.495 20.5 18.125 20.5h-2.043z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/page_layout/agent_status/icons/messaging.jsx